import { OrderType } from "@gql/offer";

export const OrdersPopupRouteName = "orders";

// add new route if needed here
export enum LimitOrderRouteName {
	LimitOrderDetail = "detail",
	LimitOrderCancel = "cancel",
	LimitOrderList = "orders",
	LimitOrderAmount = "amount",
	LimitOrderSellAmount = "sell-amount",
	LimitOrderReview = "review",
	LimitOrderSellReview = "sell-review",
	LimitOrderSuccess = "success",
	LimitOrderSellSuccess = "sell-success",
	LimitOrderCurrencySelection = "currency-selection",
	LimitOrderIntroScreen = "intro-screen",
	LimitOrderAppTest = "appropriateness-test",
	LimitOrderTypeDecision = "order-type-decision",
	MtLimitOrderDetail = "mt-detail",
	NotFound = "notfound"
}

// add new query params if needed here
export enum LimitOrderQueryParamName {
	OrderId = "OrderId",
	AssetId = "AssetId",
	FiatId = "FiatId",
	FiatWalletId = "FiatWalletId",
	WalletId = "WalletId",
	AssetdPid = "AssetPid",
	Amount = "Amount",
	TargetPrice = "TargetPrice",
	OrderCreated = "OrderCreated",
	OrderType = "OrderType",
	FilterType = "FilterType"
}

// add to collection here if there is a new QueryParamName
export interface OrdersQueryParamsCollection {
	[LimitOrderQueryParamName.OrderId]: string;
	[LimitOrderQueryParamName.AssetId]: string;
	[LimitOrderQueryParamName.FiatId]: string;
	[LimitOrderQueryParamName.FiatWalletId]: string;
	[LimitOrderQueryParamName.WalletId]: string;
	[LimitOrderQueryParamName.AssetdPid]: string;
	[LimitOrderQueryParamName.Amount]: string;
	[LimitOrderQueryParamName.TargetPrice]: string;
	[LimitOrderQueryParamName.OrderCreated]: boolean;
	[LimitOrderQueryParamName.OrderType]: OrderType;
	[LimitOrderQueryParamName.FilterType]: string;
	[LimitOrderQueryParamName.FilterType]: string;
}
